import styled, {css} from 'styled-components';

import {colors, buttonReset, border, font, transition} from 'theme';

export const Root = styled.div`
    position: relative;
    overflow: auto;
    overscroll-behavior: contain;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    max-height: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0 12px 0 0;
`;

export const SearchWrapper = styled.div`
    z-index: 2;
    background-color: white;
    position: sticky;
    top: 0;
    width: 100%;
    height: auto;
`;

export const Container = styled.div`
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0 8px;
    gap: 10px;
`;

export const CheckboxItemLine = styled.div`
    flex: 1;
    box-sizing: border-box;
    padding: 0 6px 0 0;
    text-transform: capitalize;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 18px;
`;

export const AddressSpan = styled.span`
    display: inline-flex;
    width: 100%;
    height: auto;
    flex: 1;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 14px;
`;
